import React from "react";
import BookAppointment from "./BookAppointment";

export default function index() {
  return (
    <>
      <BookAppointment />
    </>
  );
}
